import React from 'react';

const DropdownIcon = () => {
  return (
    <svg className="icon" width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.013 1.34a1.666 1.666 0 0 1 0 2.36l-11.08 11.08c-.52.52-1.36.52-1.88 0L.973 3.7a1.666 1.666 0 0 1 0-2.36 1.666 1.666 0 0 1 2.36 0L13 10.993l9.667-9.666c.64-.64 1.706-.64 2.346.013Z"
        fill="#fff"></path>
    </svg>
  );
};

export default DropdownIcon;
